import { render, staticRenderFns } from "./Oxxo.vue?vue&type=template&id=e74b3618"
import script from "./Oxxo.vue?vue&type=script&lang=js"
export * from "./Oxxo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports